export const GET_BATCH_CODE_BY_ITEM_ID_ACTION = 'GET_BATCH_CODE_BY_ITEM_ID_ACTION'
export const GET_BATCH_CODE_BY_ITEM_ID_SUCCESS = 'GET_BATCH_CODE_BY_ITEM_ID_SUCCESS'

export const STOCK_ADJUSTMENT_API_ERROR_ACTION = 'STOCK_ADJUSTMENT_API_ERROR_ACTION'
